/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';

import {
  Box,
  CircularProgress,
  Paper,
  TextareaAutosize,
  Typography,
  Divider,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Button,
  Grid,
  makeStyles
} from '@material-ui/core';
import ResultCard from 'components/resultCard';
import { ButtonView, DemoComp } from './TypingTest';
import Diff from '../../components/common/Diff';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getExerciseByCourseIdAsync } from 'store/slices/exerciseSlice/exerciseSlice';
// import { fetchExerciseByCourseIdAsync } from 'store/actions';
// import { baseURLs } from 'utils/baseURLs';
// import { useDispatch } from 'react-redux';

const useStyles = makeStyles(() => ({
  textfieldClass: {
    '& .MuiOutlinedInput-input': {
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none'
      }
    }
  },
  button: {
    outline: '0 !important',
    borderRadius: 8,
    backgroundColor: 'white',
    margin: '15px 36px',
    minWidth: '150px',
    fontSize: '18px',
    boxShadow: `0.3rem 0.3rem 0.5rem #c3c1c6, -0.2rem -0.2rem 0.4rem #fff;`,
    color: 'steelblue',
    transition: `all 0.3s ease-in-out`,
    '&:hover': {
      backgroundColor: `#a4a9fc`,
      color: '#fff'
    }
  },
  buttonOutline: {
    display: 'flex',
    flexDirection: 'row-reverse'
  }
}));
let blockEnter = false;

const TypingTestResultFooter = ({
  showRepsDataValue,
  handleChange,
  text,
  setText,
  setReplayClick,
  scrollDiv,
  scrollResult,
  wordCount,
  error,
  seconds,
  progress,
  result,
  setResult,
  prgView,
  submit,
  demo,
  repsData,
  index,
  comparison,
  instanceData,
  exerciseType,
  submitDrill,
  handleEnterEvent,
  theresultHTML,
  theresultHTML2,
  setWpmValue,
  wpmValue,
  allText,
  setKeyData,
  wordMatch,
  TimeLimit,
  counter,
  setCounter,
  attemptsRemaining,
  liftedNextButtonFunction,
  setCounterTimeoutRefs,
  setRepsData,
  setParagraph,
  innitialLineCount,
  setInnitialLineCount,
  currentDrillIndex,
  setCurrentDrillIndex
  // setTextLength
}) => {
  const navigate = useNavigate();
  const [startDrill, setStartDrill] = useState(false);
  const [time, setTime] = useState();
  const [initialTime, setInitialTime] = useState();
  const [wpmGoal, setWPMGoal] = useState(25);
  const [goal, setGoal] = useState(25);
  const [typingStarted, setTypingStarted] = useState(false);
  const classes = useStyles();
  const location = useLocation();
  const links = location.state;
  const lastID = links?.links?.[links.links.length - 1]?.id;
  const [currentExerciseIndex, setCurrentExerciseIndex] = useState(0);
  const fieldType = location.pathname.split('_')[0];
  const instanceID = location.pathname.split('-').pop();
  const [userInputRaw, setUserInputRaw] = useState([]);
  const [prevText, setPrevText] = useState('');
  const [drillText, setDrillText] = useState(instanceData.DrillText.Text[currentDrillIndex]);


  useEffect(() => {
    if (instanceData?.Activities?.Activity?.attributes?.Type == 'Video') {
      if (result) {
        liftedNextButtonFunction?.func(true);
      }
    }
  }, [result]);

  useEffect(() => {
    if (userInputRaw.length == 0) {
      let InputStructure = [];
      if (Array.isArray(repsData) && repsData.length > 0 && typeof repsData[0] === 'string') {
        InputStructure = Array(repsData.length).fill([]);
        InputStructure.forEach((_, rowIndex) => {
          //InputStructure[rowIndex] = Array(repsData[rowIndex].trim().split(' ').length).fill('');
          // Check if the element is a string before calling trim()
          if (typeof repsData[rowIndex] === 'string') {
            InputStructure[rowIndex] = Array(repsData[rowIndex].trim().split(' ').length).fill('');
          } else {
            // Handle cases where repsData[rowIndex] is not a string,
            // e.g., log a warning or set a default value
            console.warn(`Element at index ${rowIndex} in repsData is not a string.`);
            //console.log(repsData);
            // You might want to adjust the size of the inner array based on your requirements
            InputStructure[rowIndex] = [];
          }
        });
      }
      setUserInputRaw(InputStructure);
    }
  }, [repsData]);

  const prevPath = sessionStorage.getItem('pathnameForNext');
  const prevPathLastSegment = prevPath ? prevPath?.split('/').filter(Boolean).pop() : null;
  const exercises = useSelector(getExerciseByCourseIdAsync);
  // console.log(repsData, 'repsData');
  useEffect(async () => {
    localStorage.setItem('courseIdselected', location.state?.courseID, prevPathLastSegment);
    const matchingObjects = exercises
      ?.map(item => (item.id == Number(prevPathLastSegment) + 1 ? item : null))
      ?.filter(modules => modules !== null);
  }, [location.state?.courseID, prevPathLastSegment]);

  const [insertLineIndex, setInsertLineIndex] = useState(0);
  const [enterCounter, setEnterCounter] = useState(1);
  const [innitialDrilltext, setInnitialDrilText] = useState();
  const handleRespdataOnEnter = (e, callback = () => {}) => {
    if (e.key !== 'Enter') return;
    if (!innitialLineCount) {
      let lineLength = Array.isArray(repsData) ? repsData.length : repsData.split('\n').length;
      if (lineLength === 1 && Array.isArray(repsData) && repsData[0].includes('\n')) {
        lineLength = repsData[0].split('\n').length;
      }
      setInnitialLineCount(lineLength);
    }
    if (
      repsData?.length &&
      instanceData?.Activities.Activity.attributes.Type.startsWith('Timing')
    ) {
      let length =
        repsData.length === 1 && repsData[0].includes('\n')
          ? repsData[0].split('\n').length + 1
          : repsData.length ?? 0;
      setEnterCounter(enterCounter + 1);
      if (length === 0 || length > enterCounter) return;
      if (length === 1 && repsData[0].includes('\n')) {
        let data = repsData[0].split('\n').map(item => item.replace(/^[ ]+|[ ]+$/g, ''));
        const lineToInsert = data[insertLineIndex];
        data = [...data, lineToInsert];
        setRepsData([data.join(' \n ')]);
        if (userInputRaw.length != 0) {
          setUserInputRaw([...userInputRaw, Array(userInputRaw[insertLineIndex].length).fill('')]);
        }
        setParagraph([data.join(' \n ')]);
        setInsertLineIndex(insertLineIndex + 1);
      } else if (repsData.length > 0) {
        if (instanceData?.Activities.Activity.attributes.Type !== 'ReinforcementDrillKeypadEnter') {
          const lineToInsert = repsData[insertLineIndex];
          const newData = [...repsData, lineToInsert.replace(/^[ ]+|[ ]+$/g, '')];
          setRepsData(newData);
          if (userInputRaw.length != 0) {
            setUserInputRaw([
              ...userInputRaw,
              Array(userInputRaw[insertLineIndex].length).fill('')
            ]);
          }
          setInsertLineIndex(insertLineIndex + 1);
          setParagraph(newData.join(' \n '));
        }
      }
    } else if (instanceData?.Activities.Activity.attributes.Type === 'TimedShortDrill') {
      const drillTextLine = drillText?.split('\n')[insertLineIndex]?.trim() ?? '';
      if (!innitialDrilltext) setInnitialDrilText(drillText);
      if (userInputRaw.length != 0) {
        setUserInputRaw([...userInputRaw, Array(userInputRaw[insertLineIndex].length).fill('')]);
      }
      setInsertLineIndex(insertLineIndex + 1);
      setDrillText(`${drillText} \n ${drillTextLine}`);
    } else if (
      instanceData?.Activities?.Activity?.attributes?.Type === 'ReinforcementDrill' ||
      instanceData?.Activities?.Activity?.attributes?.Type === 'LocationalReinforcement' ||
      instanceData?.Activities?.Activity?.attributes?.Type === 'SentenceTiming' ||
      instanceData?.Activities?.Activity?.attributes?.Type === 'SpeedAccuracyDrill'
    ) {
      calculateWPM();
    }
    callback();
  };

  const fetchExercises = async (iditem, sessionId) => {
    localStorage.setItem('courseIdselected', iditem, sessionId);
    const currentIndex = exercises.findIndex(item => item.id == Number(sessionId));

    // Find the next exercise with visible === 1
    const nextVisibleExercise = exercises.slice(currentIndex + 1).find(item => item.visible === 1);
    if (!nextVisibleExercise) {
      // console.warn('No next visible exercise found.');
      return;
    }
    localStorage.setItem(
      'courseIdselected',
      iditem,
      nextVisibleExercise.id,
      nextVisibleExercise.name
    );

    const pathnameForNext = `/courses/courses/${nextVisibleExercise.id}`;

    navigate(pathnameForNext, {
      state: {
        modules: nextVisibleExercise.modules,
        session: nextVisibleExercise.name,
        courseID: iditem,
        links: `${nextVisibleExercise}-${iditem}`
      }
    });

    sessionStorage.setItem('pathnameForNext', pathnameForNext);
  };

  const textFieldRefs = useRef([]);
  const textareadRefs = useRef([]);

  useEffect(() => {
    if (startDrill && typingStarted) {
      if (time > 0) {
        setTimeout(() => setTime(time - 1), 1000);
      }
    } else if (['TimingKeypadTab', 'TimingKeypadEnter'].includes(exerciseType)) {
      setTime(instanceData?.Activities?.Activity?.attributes?.TimeLimit ?? 0);
    }
  }, [typingStarted, time]);

  const newhandleChange = event => {
    if (event.target.name == 'goal') {
      setGoal(event.target.value);
    }
    if (event.target.name == 'time_length') {
      setTime(event.target.value);
      setInitialTime(event.target.value);
    }
  };
  const isCompositionDrill =
    instanceData?.Activities.Activity.attributes.Type === 'CompositionDrill';
  const calculateWPM = userInp => {
    // Trim the text and split into words
    let sourceText;

    if (userInp && userInp.trim() !== '') {
      sourceText = userInp;
    } else if (!allText || allText.trim() === '') {
      sourceText = text;
    } else {
      sourceText = allText;
    }
    let words = sourceText.trim().replace(/ <br>/g, ' ').replace(/\t/g, ' ').split(/\s+/);

    // Calculate WPM
    const timeInMinutes = seconds / 60; // Convert seconds to minutes

    // Update WPM value
    let currentLine = userInp ?? comparison[comparison.length - 1] ?? '';
    let currentRep = repsData[comparison.length - 1];
    let wordCount = words.length;

    wordMatch(currentLine?.split(' '), currentRep?.split(' ') ?? '');
    const wpm = Math.round(wordCount / timeInMinutes);
    setWpmValue(wpm); // Assuming `setWpmValue` is the state updater for `wpmValue`
  };

  useEffect(() => {
    if (
      time === 0 &&
      (exerciseType === 'Timed Short Drill' ||
        instanceData?.Activities?.Activity?.attributes?.Type === 'ThinkingDrill') &&
      startDrill
    ) {
      submitDrill(text, drillText);
    }
  }, [time]);

  const isSentencetiming = 'SentenceTiming' == instanceData?.Activities.Activity.attributes.Type;
  const sentenceTimeLimit = Number(instanceData?.Activities.Activity.Title.split('-')[0] ?? 11);
  useEffect(() => {
    if (!isSentencetiming || result) {
      return;
    }
    if (counter > 0 && text.length > 0) {
      setTimeout(() => {
        blockEnter = false;
      }, 300);
    }
    if (
      !blockEnter &&
      counter == 0 &&
      textareadRefs.current.length === 1 &&
      textareadRefs.current[0]
    ) {
      blockEnter = true;
      const event = new KeyboardEvent('keydown', {
        key: 'Enter',
        code: 'Enter',
        keyCode: 13,
        which: 13,
        bubbles: true,
        cancelable: true
      });
      if (repsData.length - 1 > showRepsDataValue) {
        textareadRefs.current[0].dispatchEvent(event);
      } else {
        alert("Time's up! Auto submitting the exercise");
        submit();
      }
    }
  }, [counter]);

  const updateNextDrill = () => {
    // Helper function to reset drill state
    setInsertLineIndex(0);
    setEnterCounter(1);
    setInnitialDrilText();
    setInnitialLineCount();
    const resetDrillState = () => {
      setWPMGoal(Number(wpmGoal));
      setInitialTime(Number(initialTime));
      setTime(Number(initialTime));
      setStartDrill(true);
      setTypingStarted(false);
      setText('');
      setResult(false);
    };

    // Determine if we should advance to next drill
    const shouldAdvanceToNextDrill = () => {
      if (goal === 'Accuracy') {
        return error < 2; // Advance if error is 1 or less
      } else if (goal === 'Speed') {
        const wordsTyped = Math.max(wordCount || 0, 0); // Ensure non-negative
        const wpm = Math.floor((wordsTyped * 60) / initialTime);
        // console.log(wpm, wpmGoal);
        return wpm >= wpmGoal; // Advance if WPM goal is met
      }
      return false; // Unknown goal type
    };

    // Update drill index based on performance
    if (shouldAdvanceToNextDrill()) {
      setInnitialDrilText();
      setCurrentDrillIndex(prevIndex => prevIndex + 1);
    } else {
      if (!innitialDrilltext) {
        setDrillText(drillText);
      } else {
        setDrillText(innitialDrilltext);
      }
      setCurrentDrillIndex(prevIndex => prevIndex); // Use functional update to keep current index
    }

    // Reset drill state for next iteration
    resetDrillState();
  };

  // Add this useEffect in your component to track state changes
  useEffect(() => {
    if (currentDrillIndex >= instanceData.DrillText.Text.length) {
      setCurrentDrillIndex(0);
    }
    setDrillText(instanceData.DrillText.Text[currentDrillIndex]);
  }, [currentDrillIndex]);

  const isTimedShortDrill = ['TimedShortDrill', 'TimingKeypadEnter'].includes(
    instanceData?.Activities?.Activity?.attributes?.Type
  );

  //Timed Short Drill starting page
  if (exerciseType === 'Timed Short Drill' && !startDrill) {
    return (
      <>
        <Box
          style={{
            margin: 'auto',
            maxWidth: '95%',
            padding: '20px 0'
          }}>
          <Typography variant="h5">Drill Settings</Typography>
          <Divider style={{ height: '2px', marginTop: '10px' }} />
          <div className="Timed_short_drill">
            <div>
              <Typography variant="h6">
                <b>Goal</b>
              </Typography>
              <FormControl>
                <RadioGroup
                  name="goal"
                  aria-labelledby="demo-radio-buttons-group-label"
                  onChange={newhandleChange}>
                  <FormControlLabel
                    value="Speed"
                    control={<Radio color="default" />}
                    label="Speed"
                  />
                  <FormControlLabel
                    value="Accuracy"
                    control={<Radio color="default" />}
                    label="Accuracy"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <Typography variant="h6">
                <b>Time Length</b>
              </Typography>
              <FormControl>
                <RadioGroup
                  name="time_length"
                  aria-labelledby="demo-radio-buttons-group-label"
                  onChange={newhandleChange}>
                  <FormControlLabel
                    value="15"
                    control={<Radio color="default" />}
                    label="15 Seconds"
                  />
                  <FormControlLabel
                    value="30"
                    control={<Radio color="default" />}
                    label="30 Seconds"
                  />
                  <FormControlLabel
                    value="60"
                    control={<Radio color="default" />}
                    label="60 Seconds"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <Typography variant="h6">
                <b>WPM</b>
              </Typography>
              <Typography>Speed (20-100)</Typography>
              <br />
              <FormControl>
                <TextField
                  value={wpmGoal}
                  onChange={e => setWPMGoal(e?.target?.value ?? 0)}
                  variant="outlined"
                />
              </FormControl>
              <Button
                onClick={() => setStartDrill(true)}
                style={{
                  backgroundColor: 'green',
                  color: 'white',
                  marginLeft: '80px'
                }}>
                Start
              </Button>
            </div>
            {/* <div>
              <Button>Start</Button>
            </div> */}
          </div>
        </Box>
      </>
    );
  }

  /**
 * Handles key press events and tracks key statistics.
 *
 * This function processes key press events to track the timing and frequency of key usage.
 * It also manages mappings for specific keys (e.g., numeric keys) and updates the state
 * with the timing data for each key. Additionally, it handles correctness mapping for
 * keystrokes based on the current text length.
 *
 * @param {KeyboardEvent} e - The keyboard event triggered by a key press.
 *
 * Updates the following state:
 * - `setKeyData`: Updates the state with timing data for each key, including:
 *   - `totalTime`: Total time spent pressing the key.
 *   - `lastTimestamp`: Timestamp of the last key press.
 *   - `mapping`: Maps original characters to their corresponding key codes.
 *   - `flags`: Tracks the correctness of keystrokes based on the current text length.
 */
  const handleKeyPress = e => {
    let char = e.key;
    if (char === 'Shift' || char === 'Control' || char === 'Alt') {
      return; // Don't track these keys
    }
    if (char === 'Enter' || char === ' ') {
      return; // Don't track these keys
    }
    const originalChar = char;
    if (e.code.includes('Numpad') || e.code.includes('Digit')) {
      char = e.code;
    }
    char = char.replace(/Digit/, 'D').replace(/Numpad/, 'NumPad');
    const timestamp = Date.now(); // Current timestamp in milliseconds
    setKeyData(prevData => {
      const temp = { ...prevData };
      const keyStats = temp[char] || {
        totalTime: 0, // Total time spent pressing this key
        lastTimestamp: null, // Time of last keypress
      };

      // Update timing data
      if (keyStats.lastTimestamp) {
        const timeDiff = (timestamp - keyStats.lastTimestamp) / 1000; // Convert to seconds
        keyStats.totalTime += timeDiff; // Add time difference
      }
      keyStats.lastTimestamp = timestamp; // Update the last timestamp

      // Create mapping to determine correctness of the keystrokes.
      if (!temp.currentTextLength) temp.currentTextLength = 0;
      if (!temp.mapping) temp.mapping = {};
      if (!temp.flags) temp.flags = {};
      if (!temp.flags[char]) {
        temp.flags[char] = [];
      }
      if (!temp.mapping[originalChar] && '01234566789.'.includes(originalChar)) {
        temp.mapping[originalChar] = [];
      }
      if (!temp.flags[char].includes(temp.currentTextLength)) {
        temp.flags[char] = [...temp.flags[char], temp.currentTextLength];
        if (temp.mapping[originalChar]) temp.mapping[originalChar] = [char, ...temp.mapping[originalChar]];
      }
      temp.currentTextLength += 1;
      temp[char] = keyStats;
      return temp;
    });
  };
  // CKey-112
  const navenable = sessionStorage.getItem('navigation') === 'true';

  //Timed Short Drill Typing page
  if (exerciseType === 'Timed Short Drill' && startDrill) {
    return (
      <>
        <Box
          sx={{
            mx: '0 auto'
          }}>
          {instanceData.DrillText.Text.length != 0 ? (
            <Paper>
              <Box
                sx={{
                  py: 2,
                  px: 2,
                  mt: 2,
                  height: 'auto',
                  boxShadow: `inset 2px 2px 5px #babecc, inset -2px -2px 5px #babecc`
                }}>
                <Typography onCopy={handleChange} className="noselect" variant="inherit">
                  {instanceData ? (
                    (innitialDrilltext ?? drillText ?? '').replace(/\n /g, '\n')
                  ) : (
                    <CircularProgress size={10} color="grey" />
                  )}
                </Typography>
              </Box>
              <div className={classes.buttonOutline}>
                {lastID === Number(instanceID) ? (
                  <Button
                    onClick={() => fetchExercises(location.state?.courseID, prevPathLastSegment)}
                    className={classes.button}
                    variant="outlined">
                    Next Session
                  </Button>
                ) : (
                  <></>
                )}
              </div>
            </Paper>
          ) : (
            ''
          )}
          {result ? (
            <Box
              style={{
                width: '100%',
                backgroundColor: 'white',
                marginTop: 10,
                padding: 12,
                resize: 'none',
                borderRadius: '8px'
              }}>
              <div
                style={{
                  width: '100%',
                  backgroundColor: 'white',
                  marginTop: 10,
                  padding: 12,
                  boxShadow: `3px 3px 5px #BABECC, -3px -3px 5px #BABECC`,
                  whiteSpace: 'pre-wrap', // Keeps line breaks and whitespace formatting
                  color: 'black'
                }}
                dangerouslySetInnerHTML={{ __html: theresultHTML2 }} // Render HTML content
              />
            </Box>
          ) : (
            <>
              <TextareaAutosize
                autoCorrect="off"
                spellCheck="false"
                autoCapitalize="off"
                data-enable-grammarly="false"
                disabled={result ? true : false}
                style={{
                  width: '100%',
                  backgroundColor: 'white',
                  marginTop: 10,
                  padding: 12,
                  borderRadius: '8px',
                  resize: 'none'
                }}
                onPaste={handleChange}
                variant="outlined"
                label="Type here"
                value={text}
                placeholder="Type here"
                onKeyDown={e => {
                  handleKeyPress(e);
                  if (
                    ['ReinforcementDrillKeypadEnter', 'ReinforcementDrillKeypadTab'].includes(
                      instanceData?.Activities.Activity.attributes.Type
                    ) &&
                    ['Backspace', 'Delete'].includes(e.key)
                  ) {
                    e.preventDefault();
                    return;
                  }
                  if (e.key === 'Backspace' && ['false', 'False', '0'].includes(instanceData?.attributes.AllowBackspace) && !['Exercise 6.7:', 'Video 6.1:'].includes(instanceData?.Activities.Activity.Label)) {
                    e.preventDefault();
                    return;
                  } else if (e.key === 'Delete' && !['Exercise 6.8:', 'Video 6.2:'].includes(instanceData?.Activities.Activity.Label) && !instanceData?.Activities?.Activity?.Title?.toLowerCase().includes('delete')) {
                    e.preventDefault();
                    return;
                  }
                  handleRespdataOnEnter(e);
                  if ('TimedShortDrill' === instanceData?.Activities?.Activity?.attributes?.Type) {
                    if (['Tab'].includes(e.key)) {
                      e.preventDefault();
                      setText((e.target.value ?? '') + '\t');
                      setTypingStarted(true);
                    }
                  }
                }}
                onChange={e => {
                  if (!typingStarted) setTypingStarted(true);
                  if (e.nativeEvent.inputType == 'Tab') {
                    e.preventDefault();
                  }

                  if (!(e.nativeEvent.inputType === 'deleteContentBackward')) {
                    if (
                      e.nativeEvent.inputType === 'historyUndo' ||
                      e.nativeEvent.inputType === 'historyRedo'
                    ) {
                      e.preventDefault();
                      return false;
                    } else {
                      setText(e.target.value);
                      setReplayClick(() => false);
                      // setTextLength(e.target.value.length);
                    }
                  }
                }}
              />

              <div className={classes.buttonOutline}>
                 {/* CKey-112: Hide Navigation */}
                {navenable && lastID === Number(instanceID) ? (
                  <Button
                    onClick={() => fetchExercises(location.state?.courseID, prevPathLastSegment)}
                    className={classes.button}
                    variant="outlined">
                    Next Session
                  </Button>
                ) : (
                  <></>
                )}
              </div>
            </>
          )}
          {!isTimedShortDrill && (
            <ButtonView
              prgView={prgView}
              result={result}
              exerciseType={exerciseType}
              submit={() => submitDrill(text, drillText)}
            />
          )}
          <p>
            Time Remaining :<span>{time} sec</span>
          </p>
        </Box>
        {result && instanceData?.Activities?.Activity?.attributes?.Type !== 'Video' && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '1rem',
              justifyContent: 'end',
              alignItems: 'centre',
              paddingRight: '8rem'
            }}>
            <Box>
              <Button
                onClick={() => window.location.reload()}
                className={classes.button}
                variant="outlined">
                Start Over
              </Button>
            </Box>
            <Box>
              <Button
                onClick={() => updateNextDrill()}
                className={classes.button}
                variant="outlined">
                Continue
              </Button>
            </Box>
          </div>
        )}
        <Box ref={scrollDiv} display="flex" justifyContent="center" alignItems="center">
          <DemoComp demo={demo} instanceData={instanceData} scrollDiv={scrollDiv} />
        </Box>
        <Box
          sx={{
            marginTop: 15,
            boxShadow: `0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem #fff`,
            borderRadius: '10px'
          }}
          ref={scrollResult}>
          {result && instanceData?.Activities?.Activity?.attributes?.Type !== 'Video' && (
            <div>
              <ResultCard
                seconds={Number(
                  instanceData?.Activities?.Activity?.attributes?.TimeLimit ||
                    (exerciseType === 'Timed Short Drill' ? initialTime : seconds)
                )}
                counter={counter}
                wordCount={wordCount}
                wpmGoal={wpmGoal}
                error={error}
                orignal={repsData}
                userTxt={comparison}
                instanceData={instanceData}
                exerciseType={instanceData?.Activities?.Activity?.attributes?.Type}
                TimeLimit={instanceData?.Activities?.Activity?.attributes?.TimeLimit}
              />
              {/*
              <div style={{ marginTop: 20, padding: 12, border: '1px solid #ddd', borderRadius: 8 }}>
                <h4 style={{ marginBottom: 10 }}>Error Legend:</h4>
                <ul style={{ listStyleType: 'none', padding: 0 }}>
                  <li>
                    <span style={{ color: 'red' }}>Red:</span> Missing word
                  </li>
                  <li>
                    <span style={{ color: 'blue' }}>Blue:</span> Wrong word
                  </li>
                  <li>
                    <span style={{ color: 'orange' }}>Orange:</span> Duplicate words
                  </li>
                  <li>
                    <span style={{ color: 'green' }}>Green:</span> Numbers
                  </li>
                  <li>
                    <span style={{ color: 'darkred' }}>Dark Red:</span> Punctuation errors
                  </li>
                  <li>
                    <span style={{ color: 'purple' }}>Purple:</span> Capitalization errors
                  </li>
                </ul>
              </div>
              */}
            </div>
          )}
        </Box>
      </>
    );
  }

  //Keypad activity input
  if (
    instanceData.Activities.Activity &&
    instanceData.Activities.Activity.Title.includes('Keypad') &&
    instanceData?.Activities.Activity.attributes.Type !== 'Video'
  ) {
    let usingSplit = [];
    if (repsData[index] != undefined) {
      usingSplit = repsData[index].split(' ');
    }
    const isTiming = instanceData?.Activities?.Activity?.attributes?.Type.startsWith('Timing');
    const isLastLine = isTimedShortDrill
      ? false
      : isTiming && innitialLineCount
      ? Math.floor(enterCounter / innitialLineCount) - enterCounter / innitialLineCount == 0
      : showRepsDataValue + 1 === repsData.length;
    return (
      <>
        {!result ? (
          <Box
            sx={{
              mx: '0 auto'
            }}>
            {repsData.length !== 0 &&
            exerciseType !== 'TimingKeypadTab' &&
            exerciseType !== 'TimingKeypadEnter' ? (
              <Paper>
                <Box
                  sx={{
                    mt: 2,
                    height: 'auto',
                    boxShadow: `inset 2px 2px 5px #babecc, inset -2px -2px 5px #babecc`
                  }}>
                  <Grid container spacing={14}>
                    {repsData ? (
                      usingSplit.map((val, i) => (
                        <Grid key={i} item xs>
                          <TextField
                            disabled={true}
                            variant="outlined"
                            value={val}
                            required
                            size="small"
                            type="number"
                          />
                        </Grid>
                      ))
                    ) : (
                      <CircularProgress size={10} color="grey" />
                    )}
                  </Grid>
                </Box>
              </Paper>
            ) : null}

            <Grid
              style={{
                width: '100%',
                backgroundColor: 'white',
                marginTop: 10,
                padding: 12,
                borderRadius: '8px',
                resize: 'none'
              }}
              container
              spacing={14}>
              {usingSplit.map((val, i) => (
                <Grid key={i} item xs>
                  <TextField
                    className={classes.textfieldClass}
                    variant="outlined"
                    required
                    type="number"
                    inputRef={el => (textFieldRefs.current[i] = el)} // Attach to refs array
                    onKeyDown={e => {
                      if (
                        [
                          'DrillLinesKeypadEnter',
                          'ReinforcementDrillKeypadEnter',
                          'TimingKeypadEnter'
                        ].includes(instanceData?.Activities.Activity.attributes.Type)
                      ) {
                        if ('Tab' === e.key) {
                          e.preventDefault();
                          return;
                        } else if ('Enter' === e.key && i !== usingSplit.length - 1) {
                          textFieldRefs.current[i + 1].focus();
                          return;
                        }
                      }
                      if (
                        ['ReinforcementDrillKeypadEnter', 'ReinforcementDrillKeypadTab'].includes(
                          instanceData?.Activities.Activity.attributes.Type
                        ) &&
                        ['Backspace', 'Delete'].includes(e.key)
                      ) {
                        e.preventDefault();
                        return;
                      }
                      if (e.key === 'Backspace' && ['false', 'False', '0'].includes(instanceData?.attributes.AllowBackspace) && !['Exercise 6.7:', 'Video 6.1:'].includes(instanceData?.Activities.Activity.Label)) {
                        e.preventDefault();
                        return;
                      } else if (e.key === 'Delete' && !['Exercise 6.8:', 'Video 6.2:'].includes(instanceData?.Activities.Activity.Label) && !instanceData?.Activities?.Activity?.Title?.toLowerCase().includes('delete')) {
                        e.preventDefault();
                        return;
                      }
                      if (i === usingSplit.length - 1) handleRespdataOnEnter(e);
                      if (
                        ['TimingKeypadTab', 'TimingKeypadEnter'].includes(exerciseType) &&
                        counter == 0
                      ) {
                        e.preventDefault();
                        return;
                      } else if (['TimingKeypadTab', 'TimingKeypadEnter'].includes(exerciseType)) {
                        if (!startDrill) setStartDrill(true);
                        if (!typingStarted) setTypingStarted(true);
                      }
                      handleKeyPress(e);
                      if (['Tab', 'Enter'].includes(e.key)) {
                        setUserInputRaw(prev => {
                          const inputLength = `${usingSplit[i] ?? ''}`.length;
                          prev[index][i] = (e.target.value ?? '').padEnd(inputLength, '⧗');
                          return prev;
                        });

                        if (e.key === 'Tab' && i === usingSplit.length - 1) {
                          e.preventDefault();
                        } else if (e.key === 'Tab') {
                          textFieldRefs.current[i].focus();
                        } else if (e.key === 'Enter') {
                          e.preventDefault();
                          const isLastInput = i === usingSplit.length - 1;
                          if (isLastInput) {
                            setCurrentExerciseIndex(currentExerciseIndex + 1);
                            if (textFieldRefs.current[0]) {
                              textFieldRefs.current[0].focus();
                              if (
                                'ReinforcementDrillKeypadEnter' !==
                                  instanceData?.Activities.Activity.attributes.Type ||
                                instanceData?.Activities.Activity.attributes.Type !==
                                  'ReinforcementDrillKeypadTab'
                              ) {
                                if (
                                  repsData.length - 1 !== showRepsDataValue ||
                                  instanceData?.Activities.Activity.attributes.Type.startsWith(
                                    'Timing'
                                  )
                                ) {
                                  textFieldRefs.current.forEach(item => {
                                    if (item) item.value = '';
                                  });
                                }
                              }
                            }
                            calculateWPM();
                            handleEnterEvent(true);
                          } else {
                            textFieldRefs.current[i].focus();
                          }
                        }
                      }
                    }}
                    onChange={e => {
                      setUserInputRaw(prev => {
                        // console.log(prev);
                        const inputLength = `${usingSplit[i] ?? ''}`.length;
                        prev[index][i] = (e.target.value ?? '').padEnd(inputLength, '⧗');
                        setText(prev[index].join(' '));
                        return prev;
                      });
                    }}
                  />
                  <div className={classes.buttonOutline}>
                    {/* CKey-112: Hide Navigation */}
                    {navenable && lastID === Number(instanceID) ? (
                      <Button
                        onClick={() =>
                          fetchExercises(location.state?.courseID, prevPathLastSegment)
                        }
                        className={classes.button}
                        variant="outlined">
                        Next Session
                      </Button>
                    ) : null}
                  </div>
                </Grid>
              ))}
            </Grid>

            {isLastLine && (
              <ButtonView
                prgView={prgView}
                result={result}
                exerciseType={exerciseType}
                submit={submit}
              />
            )}
            {time &&
            !['TimingKeypadTab', 'TimingKeypadEnter'].includes(exerciseType) &&
            time != 0 ? (
              <p>
                Time Remaining :<span> {time ?? 0} sec</span>
              </p>
            ) : (
              <></>
            )}
          </Box>
        ) : (
          <>
            {!['0', 'false', 'False'].includes(
              instanceData?.Activities?.Activity?.attributes?.DisplayErrors
            ) && (
              <Box
                sx={{
                  py: 2,
                  px: 2,
                  mt: 2,
                  height: '300px', // Set a maximum height
                  maxHeight: '300px', // Set maximum height
                  width: '100%', // Full width
                  overflowY: 'auto', // Enable vertical scrolling
                  overflowX: 'hidden', // Hide horizontal overflow
                  boxShadow: `inset 2px 2px 5px #babecc, inset -2px -2px 5px #babecc`,
                  backgroundColor: '#fff'
                }}>
                <Typography
                  onCopy={handleChange}
                  className="noselect"
                  variant="inherit"
                  sx={{
                    '& span': {
                      display: 'block', // Forces each <span> to appear on a new line
                      marginTop: '2px' // Optional: Adds space between lines for readability
                    }
                  }}
                  dangerouslySetInnerHTML={{ __html: theresultHTML }}
                />
              </Box>
            )}
            <>
              <div
                style={{
                  width: '100%',
                  backgroundColor: 'white',
                  marginTop: 10,
                  padding: 12,
                  boxShadow: `3px 3px 5px #BABECC, -3px -3px 5px #BABECC`,
                  whiteSpace: 'pre-wrap', // Keeps line breaks and whitespace formatting
                  color: 'black'
                }}
                dangerouslySetInnerHTML={{ __html: theresultHTML2 }} // Render HTML content
              />
              <div className={classes.buttonOutline}>
                {/* CKey-112: Hide Navigation */}
                {navenable && lastID === Number(instanceID) ? (
                  <Button
                    onClick={() => fetchExercises(location.state?.courseID, prevPathLastSegment)}
                    className={classes.button}
                    variant="outlined">
                    Next Session
                  </Button>
                ) : (
                  <></>
                )}
              </div>
            </>
          </>
        )}

        <Box ref={scrollDiv} display="flex" justifyContent="center" alignItems="center">
          <DemoComp demo={demo} instanceData={instanceData} scrollDiv={scrollDiv} />
        </Box>
        <Box
          sx={{
            marginTop: 15,
            boxShadow: `0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem #fff`,
            borderRadius: '10px'
          }}
          ref={scrollResult}>
          {result && instanceData?.Activities?.Activity?.attributes?.Type !== 'Video' && (
            <div>
              <ResultCard
                seconds={Number(
                  instanceData?.Activities?.Activity?.attributes?.TimeLimit ?? seconds
                )}
                wordCount={wordCount}
                error={error}
                counter={counter}
                wpmValue={wpmGoal}
                orignal={repsData}
                userTxt={comparison}
                instanceData={instanceData}
                exerciseType={instanceData?.Activities?.Activity?.attributes?.Type}
                TimeLimit={instanceData?.Activities?.Activity?.attributes?.TimeLimit}
              />
              {/*
              <div
                style={{ marginTop: 20, padding: 12, border: '1px solid #ddd', borderRadius: 8 }}>
                <h4 style={{ marginBottom: 10 }}>Error Legend:</h4>
                <ul style={{ listStyleType: 'none', padding: 0 }}>
                  <li>
                    <span style={{ color: 'red' }}>Red:</span> Missing word
                  </li>
                  <li>
                    <span style={{ color: 'blue' }}>Blue:</span> Wrong word
                  </li>
                  <li>
                    <span style={{ color: 'orange' }}>Orange:</span> Duplicate words
                  </li>
                  <li>
                    <span style={{ color: 'green' }}>Green:</span> Numbers
                  </li>
                  <li>
                    <span style={{ color: 'darkred' }}>Dark Red:</span> Punctuation errors
                  </li>
                  <li>
                    <span style={{ color: 'purple' }}>Purple:</span> Capitalization errors
                  </li>
                </ul>
              </div>
              */}
            </div>
          )}
        </Box>
      </>
    );
  }

  //Default Typing Input box
  return (
    <>
      <Box
        sx={{
          mx: '0 auto'
        }}>
        {repsData.length !== 0 && exerciseType !== 'ReinforcementDrill' ? (
          <Paper>
            {!result ? (
              <Box
                sx={{
                  py: 2,
                  px: 2,
                  mt: 2,
                  height: 'auto',
                  boxShadow: `inset 2px 2px 5px #babecc, inset -2px -2px 5px #babecc`
                }}>
                <Typography onCopy={handleChange} className="noselect" variant="inherit">
                  {repsData ? (
                    repsData[index]
                      .split('|')
                      .map((item, index) => (index % 2 === 0 ? item.replace(/[{}]/g, '') : '___'))
                      .join('')
                      .replace('___ {}', '')
                  ) : (
                    <CircularProgress size={10} color="grey" />
                  )}
                </Typography>
              </Box>
            ) : !['0', 'false', 'False'].includes(
                instanceData?.Activities?.Activity?.attributes?.DisplayErrors
              ) ? (
              <Box
                sx={{
                  py: 2,
                  px: 2,
                  mt: 2,
                  height: 'auto', // Set a maximum height
                  maxHeight: '300px', // Set maximum height
                  width: '100%', // Full width
                  overflowY: 'auto', // Enable vertical scrolling
                  overflowX: 'hidden', // Hide horizontal overflow
                  boxShadow: `inset 2px 2px 5px #babecc, inset -2px -2px 5px #babecc`
                }}>
                <Typography
                  onCopy={handleChange}
                  className="noselect"
                  variant="inherit"
                  sx={{
                    '& span': {
                      display: 'block', // Forces each <span> to appear on a new line
                      marginTop: '2px' // Optional: Adds space between lines for readability
                    }
                  }}
                  dangerouslySetInnerHTML={{ __html: theresultHTML }}
                />
              </Box>
            ) : (
              <></>
            )}
          </Paper>
        ) : (
          ''
        )}

        {!result ? (
          <>
            <TextareaAutosize
              autoCorrect="off"
              spellCheck="false"
              autoCapitalize="off"
              data-enable-grammarly="false"
              disabled={false} // Editable when `result` is false
              style={{
                width: '100%',
                backgroundColor: 'white',
                marginTop: 10,
                padding: 12,
                borderRadius: '8px',
                resize: 'none'
              }}
              onPaste={handleChange}
              ref={el => (textareadRefs.current[0] = el)} // Attach to refs array
              variant="outlined"
              label="Type here"
              value={text}
              placeholder="Type here"
              onKeyDown={e => {
                //if activity type is ReinforcementDrillKeypadEnter or ReinforcementDrillKeypadTab prevent delete and backspace
                if (
                  ['ReinforcementDrillKeypadEnter', 'ReinforcementDrillKeypadTab'].includes(
                    instanceData?.Activities.Activity.attributes.Type
                  ) &&
                  ['Backspace', 'Delete'].includes(e.key)
                ) {
                  e.preventDefault();
                  return;
                }

                //prevent backspace if allowBackspace for course is false and activity is not 'Exercise 6.7:' or 'Video 6.1:'
                if (e.key === 'Backspace' && ['false', 'False', '0'].includes(instanceData?.attributes.AllowBackspace) && !['Exercise 6.7:', 'Video 6.1:'].includes(instanceData?.Activities.Activity.Label)) {
                  e.preventDefault();
                  return;
                } //prevent delete if allowBackspace for course is false and activity is not 'Exercise 6.8:' or 'Video 6.2:'
                else if (e.key === 'Delete' && !['Exercise 6.8:', 'Video 6.2:'].includes(instanceData?.Activities.Activity.Label) && !instanceData?.Activities?.Activity?.Title?.toLowerCase().includes('delete')) {
                  e.preventDefault();
                  return;
                }

                
                handleRespdataOnEnter(e);

                if (e.key === 'Enter' && isSentencetiming) {
                  setCounterTimeoutRefs(prev => {
                    prev.forEach(item => {
                      clearTimeout(item);
                    });
                    return [];
                  });
                  setCounter(sentenceTimeLimit);
                  blockEnter = true;
                }

                const exetype = fieldType.split('/').pop();
                
                //track key stats
                handleKeyPress(e);

                //handeling for the enter key
                if (e.key === 'Enter') {
                  if (exetype.trim() !== 'Timing') {
                    handleEnterEvent();
                    e.preventDefault();
                  }

                  // Function to calculate WPM
                  let words = '';
                  if (prevText) {
                    words = prevText + ' <br>' + text;
                  } else {
                    words = text;
                  }
                  if (
                    isCompositionDrill &&
                    !instanceData?.Activities.Activity.Title.includes('Practice')
                  ) {
                    setPrevText(words);
                  }
                  // Calculate WPM and update the state
                  const isNeedToCalculate = ['Timing', 'Document'].includes(
                    instanceData?.Activities.Activity.attributes.Type
                  );
                  isNeedToCalculate ? calculateWPM() : '';
                }

                //handeling for the tab key
                if (e.code === 'Tab') {
                  if (
                    exerciseType === 'Timing' ||
                    ((exerciseType === 'DrillLines' || exerciseType === 'ReinforcementDrill') &&
                      instanceData.Activities.Activity.Title.includes('Tab Drill'))
                  ) {
                    // Custom Tab behavior for Timing exercises
                    if (!instanceData.Activities.Activity.Title.includes('Keypad')) {
                      e.preventDefault();
                      setText(text + '\t'); // Adds four spaces
                      return;
                    }
                  }

                  if (instanceData?.Activities?.Activity?.attributes?.Type == 'Video') {
                    e.preventDefault();
                    setText(text + '\t');
                    return;
                  }

                  if (isCompositionDrill) {
                    e.preventDefault();
                    setText((e.target.value ?? '') + '\t');
                    setReplayClick(() => false);
                    return;
                  }
                }
              }}
              onChange={e => {
                if (text.length - e.target.value.length == 1) {
                  setText(e.target.value);
                  setReplayClick(() => false);
                  return;
                }
                if (exerciseType !== 'CompositionDrill') {
                  if (e.nativeEvent.inputType !== 'deleteContentBackward') {
                    if (['historyUndo', 'historyRedo'].includes(e.nativeEvent.inputType)) {
                      e.preventDefault();
                      return;
                    } else {
                      setText(e.target.value);
                      setReplayClick(() => false);
                    }
                  }
                } else {
                  setText(e.target.value);
                  setReplayClick(() => false);
                }
              }}
            />

            <div className={classes.buttonOutline}>
              {/* CKey-112: Hide Navigation */}
              {navenable && lastID === Number(instanceID) ? (
                <Button
                  onClick={() => fetchExercises(location.state?.courseID, prevPathLastSegment)}
                  className={classes.button}
                  variant="outlined">
                  Next Session
                </Button>
              ) : (
                <></>
              )}
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                width: '100%',
                backgroundColor: 'white',
                marginTop: 10,
                padding: 12,
                boxShadow: `3px 3px 5px #BABECC, -3px -3px 5px #BABECC`,
                whiteSpace: 'pre-wrap', // Keeps line breaks and whitespace formatting
                color: 'black'
              }}
              dangerouslySetInnerHTML={{ __html: theresultHTML2 }} // Render HTML content
            />
            <div className={classes.buttonOutline}>
              {/* CKey-112: Hide Navigation */}
              {navenable && lastID === Number(instanceID) ? (
                <Button
                  onClick={() => fetchExercises(location.state?.courseID, prevPathLastSegment)}
                  className={classes.button}
                  variant="outlined">
                  Next Session
                </Button>
              ) : (
                <></>
              )}
            </div>
          </>
        )}

        {(showRepsDataValue + 1 === repsData?.length || repsData?.length === 0) &&
        !isTimedShortDrill ? (
          <ButtonView
            prgView={prgView}
            result={result}
            exerciseType={exerciseType}
            submit={e => {
              if (repsData?.length === 0) {
                let finalWord =
                  (isCompositionDrill &&
                  !instanceData?.Activities.Activity.Title.includes('Practice')
                    ? prevText + ' <br>'
                    : '') + text;
                finalWord = finalWord.replace(/\n/g, ' <br>');
                submitDrill(finalWord.replace(/\t/g, ' '), repsData);
              } else {
                submit(e);
              }
            }}
          />
        ) : null}
      </Box>
      <Box ref={scrollDiv} display="flex" justifyContent="center" alignItems="center">
        <DemoComp demo={demo} instanceData={instanceData} scrollDiv={scrollDiv} />
      </Box>
      <Box
        sx={{
          marginTop: 15,
          boxShadow: `0.3rem 0.3rem 0.5rem rgb(195 193 198 / 90%), -0.2rem -0.2rem 0.4rem #fff`,
          borderRadius: '10px'
        }}
        ref={scrollResult}>
        {result &&
          ((progress == 100 && instanceData?.Activities?.Activity?.attributes?.Type !== 'Video') ||
            instanceData?.Activities?.Activity?.attributes?.Type === 'Timing') && (
            <div>
              <ResultCard
                seconds={Number(
                  instanceData?.Activities?.Activity?.attributes?.TimeLimit ?? seconds
                )}
                instanceData={instanceData}
                wordCount={wordCount}
                error={error}
                counter={counter}
                orignal={repsData}
                userTxt={comparison}
                wpmValue={wpmValue}
                exerciseType={instanceData?.Activities?.Activity?.attributes?.Type}
                TimeLimit={instanceData?.Activities?.Activity?.attributes?.TimeLimit}
              />
              {/*
              <div
                style={{ marginTop: 20, padding: 12, border: '1px solid #ddd', borderRadius: 8 }}>
                <h4 style={{ marginBottom: 10 }}>Error Legend:</h4>
                <ul style={{ listStyleType: 'none', padding: 0 }}>
                  <li>
                    <span style={{ color: 'red' }}>Red:</span> Missing word
                  </li>
                  <li>
                    <span style={{ color: 'blue' }}>Blue:</span> Wrong word
                  </li>
                  <li>
                    <span style={{ color: 'orange' }}>Orange:</span> Duplicate words
                  </li>
                  <li>
                    <span style={{ color: 'green' }}>Green:</span> Numbers
                  </li>
                  <li>
                    <span style={{ color: 'darkred' }}>Dark Red:</span> Punctuation errors
                  </li>
                  <li>
                    <span style={{ color: 'purple' }}>Purple:</span> Capitalization errors
                  </li>
                </ul>
              </div>
              */}
            </div>
          )}
      </Box>
    </>
  );
};

export default TypingTestResultFooter;
